var map = {
	"./ACDC.svg": "VFME",
	"./CO2.svg": "d0dh",
	"./add.svg": "4cSG",
	"./alarm.svg": "YdUd",
	"./app-deviceMap.svg": "aNBJ",
	"./app-display.svg": "0KR6",
	"./app-electricity.svg": "Wi3d",
	"./app-inspect.svg": "uARr",
	"./app-insurance.svg": "JDc9",
	"./app-ivScan.svg": "seIU",
	"./app-maintenance.svg": "Nenf",
	"./app-more.svg": "9rRM",
	"./app-networking.svg": "2wsP",
	"./app-report.svg": "5min",
	"./app-sim.svg": "n5vR",
	"./app-virtualWeatherStation.svg": "P3bf",
	"./arrow-d.svg": "p06T",
	"./arrow-l.svg": "HOFY",
	"./arrow-r.svg": "toOo",
	"./arrow-u.svg": "5EjI",
	"./arrowDouble-d.svg": "kV/y",
	"./batchmenu.svg": "WqPv",
	"./battery-0.svg": "VN5f",
	"./battery-1.svg": "vOfO",
	"./battery-2.svg": "FmUx",
	"./battery-3.svg": "lxX+",
	"./battery-4.svg": "phDE",
	"./battery-5.svg": "BG/+",
	"./battery-unknow.svg": "tvrW",
	"./battery.svg": "q4P9",
	"./bell.svg": "FvmK",
	"./build.svg": "WmWN",
	"./cha.svg": "H4fz",
	"./chrome.svg": "bcEZ",
	"./classification.svg": "BORd",
	"./clone.svg": "Y3To",
	"./close.svg": "usbd",
	"./coal.svg": "y1M8",
	"./config.svg": "ZfcP",
	"./ctrl.svg": "NCJS",
	"./danger.svg": "vyad",
	"./dangerAll.svg": "rs4T",
	"./deploy.svg": "UHu3",
	"./dirArrow-l.svg": "Ptaq",
	"./dirArrow-r.svg": "axVX",
	"./display-CO2.svg": "XnpG",
	"./display-light.svg": "dqrn",
	"./display-plant-a.svg": "F4ss",
	"./display-plant-b.svg": "JDMw",
	"./display-plant.svg": "Mm4F",
	"./display-purse.svg": "hgr4",
	"./display-tree.svg": "RlaZ",
	"./display.svg": "6ZRZ",
	"./displayConfig-title.svg": "ygNt",
	"./distr.svg": "U5fc",
	"./download.svg": "UXgm",
	"./dv-DTU.svg": "SZjD",
	"./dv-battery.svg": "y5gH",
	"./dv-combinerBox.svg": "KQE8",
	"./dv-comp.svg": "euQT",
	"./dv-fan.svg": "gd0Y",
	"./dv-inverter.svg": "q/uf",
	"./dv-logger.svg": "rK07",
	"./dv-meter.svg": "yeUM",
	"./dv-microInverter.svg": "9PNy",
	"./dv-repeater.svg": "BhAU",
	"./dv-weatherStation.svg": "AcLm",
	"./eTower.svg": "qxXn",
	"./edit-project.svg": "ZXGT",
	"./edit-sub.svg": "o9Fp",
	"./edit.svg": "KJUk",
	"./email.svg": "i1m2",
	"./etc-o.svg": "ou0O",
	"./export.svg": "uPuA",
	"./fileType-damage.svg": "Gri2",
	"./fileType-excel.svg": "h0oj",
	"./fileType-file.svg": "HwBL",
	"./fileType-pdf.svg": "28+Z",
	"./fileType-text.svg": "PY3c",
	"./fileType-word.svg": "nlge",
	"./filter.svg": "PTMJ",
	"./firefox.svg": "94o/",
	"./fold.svg": "UWrL",
	"./fullScreen.svg": "kVC+",
	"./help.svg": "/9hz",
	"./helpTip.svg": "XJgd",
	"./home.svg": "J8GQ",
	"./house.svg": "LCIe",
	"./ico-1.svg": "txF0",
	"./ico-2.svg": "2///",
	"./import.svg": "aYs0",
	"./incFace.svg": "Sct3",
	"./inspect-cover.svg": "oTFP",
	"./inspect-multiple.svg": "8e2+",
	"./inspect-single.svg": "eh8I",
	"./link.svg": "s3+7",
	"./list.svg": "lFS3",
	"./load.svg": "83p3",
	"./location.svg": "C5qe",
	"./map.svg": "IxiL",
	"./marker.svg": "LLbh",
	"./menu-1.svg": "fcpi",
	"./menu-10.svg": "JV+6",
	"./menu-11.svg": "27Ve",
	"./menu-12.svg": "qjFN",
	"./menu-13.svg": "+xok",
	"./menu-14.svg": "g5FX",
	"./menu-2.svg": "vgP0",
	"./menu-3.svg": "aKJR",
	"./menu-4.svg": "4DPq",
	"./menu-5.svg": "8u6G",
	"./menu-6.svg": "3tQT",
	"./menu-7.svg": "oXM3",
	"./menu-8.svg": "WxB6",
	"./menu-9.svg": "d3mQ",
	"./menu-data-on.svg": "2xhU",
	"./menu-inspect.svg": "2Idb",
	"./menu-layer.svg": "Fwgo",
	"./menu-tag.svg": "N8Tc",
	"./menu-user-option.svg": "YfD5",
	"./menu-user.svg": "DTTz",
	"./menu-users.svg": "JSBU",
	"./more.svg": "3/hf",
	"./no.svg": "Eg9J",
	"./noAlarm.svg": "NsMW",
	"./noCommunication.svg": "65dF",
	"./noData.svg": "lLLd",
	"./noMessage.svg": "Ylw0",
	"./offline-all.svg": "MIQc",
	"./offline-part.svg": "o3eg",
	"./on.svg": "MFTv",
	"./outRelation.svg": "w3Rr",
	"./outRelations.svg": "mVBQ",
	"./outRole.svg": "jxzN",
	"./persenSetting.svg": "FgUF",
	"./phone.svg": "RH/p",
	"./photo.svg": "5vuh",
	"./plant-wind-o.svg": "Orq2",
	"./plant-wind.svg": "SvB/",
	"./plant.svg": "UZK/",
	"./posArrow-up.svg": "gyH+",
	"./preview.svg": "Zwwz",
	"./productManage.svg": "z19k",
	"./providerIcon.svg": "2n8G",
	"./question.svg": "mqUg",
	"./reInspect.svg": "CDyZ",
	"./recycle.svg": "palW",
	"./reduce.svg": "bjWj",
	"./refresh.svg": "wK1c",
	"./relieve.svg": "aVl7",
	"./reload.svg": "hGTH",
	"./resend.svg": "DbRJ",
	"./resetView.svg": "i4nH",
	"./satellite-off.svg": "mdtO",
	"./satellite-on.svg": "WOG5",
	"./satellite.svg": "C1H3",
	"./service.svg": "xGWY",
	"./serviceprovider.svg": "mCAt",
	"./setting.svg": "JWg3",
	"./setup.svg": "pWza",
	"./shield-danger.svg": "S7i+",
	"./shield-save.svg": "IH71",
	"./shield-yes-o.svg": "1b4q",
	"./shield-yes.svg": "L2Nn",
	"./show.svg": "vsUp",
	"./site.svg": "8dZV",
	"./sizeCtrl.svg": "ribp",
	"./solarEnergy.svg": "DN5R",
	"./star-off.svg": "mUd6",
	"./star-on.svg": "wOTZ",
	"./status-alarm.svg": "2PY7",
	"./status-info.svg": "J5Nu",
	"./status-success.svg": "82HO",
	"./status-warning.svg": "KvwK",
	"./stoptask.svg": "7RWK",
	"./sunrise.svg": "zOBz",
	"./sunset.svg": "E7B6",
	"./tag.svg": "j6Ty",
	"./temp.svg": "8bpX",
	"./time.svg": "vsvj",
	"./tipArrow.svg": "Jjaf",
	"./totalIncome.svg": "r/zG",
	"./transfer.svg": "KsWh",
	"./trash.svg": "Ubxc",
	"./tree.svg": "ArG6",
	"./unFullScreen.svg": "IlIn",
	"./unfold.svg": "vD+H",
	"./unlink.svg": "NPuX",
	"./unon.svg": "P/W0",
	"./update.svg": "+hax",
	"./upgrade.svg": "hgk7",
	"./userFace.svg": "Scbf",
	"./wind.svg": "8gsG",
	"./windSpeed.svg": "ttwx",
	"./yes.svg": "kWg0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VY/N";


//////////////////
// WEBPACK FOOTER
// ./src/icons/common nonrecursive \.svg$
// module id = VY/N
// module chunks = 264